import _ from 'lodash';
import { Record } from 'immutable';
import CookieDough from 'cookie-dough';

const isBrowser = typeof window !== 'undefined';
const env = (isBrowser ? window.ENV : process.env.NODE_ENV) || 'development';
const ExperimentsCookieOptions = {
  path: '/',
  secure: env === 'staging' || env === 'production'
};
const DefaultExperimentSettings = {
  download_banner_dismissed: false
};
const ExperimentSettingsCookieKey = 'banquet_x';

class ExperimentSettings extends Record(DefaultExperimentSettings) {}

/**
 * @param {Object} options
 * @param {String} options.experimentSettings
 * @param {Object} options.req
 * @returns {ExperimentsPlugin}
 */
function ExperimentsPlugin(options) {
  let cookie;
  if(!isBrowser) {
    cookie = new CookieDough(options.req);
  } else {
    cookie = CookieDough();
  }

  let values = cookie.get(ExperimentSettingsCookieKey);
  if(values) {
    values = JSON.parse(decodeURIComponent(values));
  }
  let experimentSettings = new ExperimentSettings(values);

  let getExperimentSetting = (key) => {
    return experimentSettings.get(key);
  };

  let setExperimentSetting = (key, value) => {
    experimentSettings = experimentSettings.set(key, value);
    cookie.set(ExperimentSettingsCookieKey, encodeURIComponent(JSON.stringify(experimentSettings.toJSON())), ExperimentsCookieOptions);
  };

  return {
    name: 'ExperimentsPlugin',
    plugContext: function() {
      return {
        plugActionContext: function(actionContext) {
          actionContext.getExperimentSetting = getExperimentSetting;
          actionContext.setExperimentSetting = setExperimentSetting;
        },
        plugComponentContext: function(componentContext) {
          componentContext.getExperimentSetting = getExperimentSetting;
          componentContext.setExperimentSetting = setExperimentSetting;
        }
      };
    }
  };
}

export default ExperimentsPlugin;



// WEBPACK FOOTER //
// banquet/plugins/ExperimentsPlugin.js